import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import { setStorage } from '@/utils'
import {getTenantByCode} from '@/api/databaseBin'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/Home'
  },
  {
    path: '/Home',
    name: 'Home',
    component: () => import('@/views/Home'),
    meta: {
      title: '首页'
    },
    children: [

    ]
  },
  {
    path: '/versionOne',
    name: 'versionOne',
    component: () => import('@/views/versionOne'),
    meta: {
      title: '首页'
    },
    children: [

    ]
  },
  {
    path: '/versionTwo',
    name: 'versionTwo',
    component: () => import('@/views/versionTwo'),
    meta: {
      title: '首页'
    },
    children: [

    ]
  }
]

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const router = new VueRouter({
  // mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes
})

// 处理路由跳转后的，顶部菜单栏操作
router.beforeEach((to, from, next) => {
  const query = to.query
  if (Object.keys(query).length > 0) {
    localStorage.removeItem('token')
    localStorage.removeItem('logo')
    localStorage.removeItem('user')
    let obj = {}
    if (query.name && query.name !== '') {
      obj = {
        code: query.code,
        tenantId: query.tenantId,
        digitalStyle: query.digitalStyle || 0,
        jumpToken: query.jumpToken,
        jumpRefreshToken: query.jumpRefreshToken
      }
      if (query.logo) {
        setStorage('logo', query.logo, 0)
      }
      setStorage('user', obj, 0)
      store.dispatch('user/XZSLogin', obj).then(res => {
        // 根据接受的主题类型来显示

        switch (Number(query.digitalStyle)) {
          case 0:
            next('/')
            break
          case 1:
            next('/versionOne')
            break
          case 2:
            next('/versionTwo')
            break
          default:
            next('/')
            break
        }
      })
    } else {
      obj = {account: query.account, tenantId: query.tenantId, tenantNameCN: query.tenantNameCN, code: query.code }
      setStorage('user', obj, 0)
      store.dispatch('user/LoginForm', obj).then(res => {
        router.push('/')
      })
    }
  } else {
    let code = 'sale'
    if (process.env.NODE_ENV === 'development') {
      // 本地服务
      code = 'lnstsg'
      // code = 'sale' // pre
      // code = 'ourchem' // pro
      if (to.query.code && to.query.code !== '') {
        code = to.query.code
      }
    } else {
      // 线上服务
      const hostname = window.location.hostname
      const arr = hostname.split('.')
      code = arr[0]
    }
    getTenantByCode(code).then(async res => {
      if (res.code === 200) {
        const tenantId = res.data.id
        const typeCode = res.data.typeCode
        const obj = {
          code,
          tenantId,
          typeCode
        }

        setStorage('user', obj, 0)
        setStorage('tenantType', typeCode, 0)
        let title = ''
        if (typeCode === 'school') {
          title = '学院专利数量统计'
        } else if (typeCode === 'government') {
          title = '技术领域专利数量统计'
        } else {
          title = '部门组织专利数量统计'
        }
        store.dispatch('title/updateTitle', title)
        if (typeCode === 'government') {
          await store.dispatch('user/XZSLogin', obj)
        } else {
          store.dispatch('user/XZSLogin', obj)
        }
        // store.dispatch('user/XZSLogin', obj)
      }
    }).finally(() => {
      next()
    })
  }
})

export default router
